import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.less'
})
export class AvatarComponent {
  @Input() src: string | undefined = undefined;
  @Input() alt: string = '';
  
  hasError = false;

  onImageError() {
    this.hasError = true;
  }
}
